//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "loader",
};
